import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Input, Tooltip, Button, Modal } from 'components';
import { CleanIcon, EditIcon, DeleteIcon, AddIcon, EyeBlackIcon } from 'assets/icons';
import moment from 'moment';
import { QuoteService } from 'services';
import { Globals, Constants, Print } from 'utils';
import ModalCreate from './modal-create';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	service: ''
}

class Quotes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha de solicitud',
			'Tipo de Cirugía',
			'Paciente',
			'Solicitudes',
			'Leidas',
			'Nuevas',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false, 
		item: null,
		visible_view: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Cotizacion Cirugías',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await QuoteService.doctor.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			user_id: this.props.user?.id,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		if (!res.continue) {
			this.props.history.replace('/doctor/home');
			Globals.showError("Lo sentimos, para entrar al módulo de cotizaciones debe realizar el pago de su plan");
		}
		else {
			this.setState({
				data: res.quotes.rows,
				last_page: res.quotes.count
			});
		}
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});	
	}

	add = () => {
		this.setState({
			visible: true
		});	
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la cotización?',async () => {
			await QuoteService.doctor.delete({
				quote_id: item.id
			});
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	download = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await QuoteService.doctor.download({
			quote_id: item?.id
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}
	
	render() {
		const { visible, visible_view } = this.state;

		return (
			<div id="doctor-quotes">
				<Modal
		          className="modal-doctor-create-quote"
		          visible={ visible }
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalCreate
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-doctor-view-quote"
		          visible={ visible_view }
		          withoutClose={ true }
		          onClose={ () => this.onCloseView() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalView
		          	item={ this.state.item }
		            onClose={ () => this.onCloseView() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-4">
						<Input
							value={ this.state.form.search }
							name="search"
							label="Buscar por paciente"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-4">
						<Input
							value={ this.state.form.service }
							name="service"
							label="Tipo de Cirugía"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-4"></div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Desde"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'since'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.since }
						/>
					</div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Hasta"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'until'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.until }
						/>
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table title="Historial de Cotización" data={ this.state.data.length } rightAlign={[ 6 ]} header={ this.state.header } titleRight={
					<Button className="btn-add" onClick={ () => this.add() }>
						<img src={ AddIcon } />
						Nuevo
					</Button>
				}>
					{ this.state.data.map((i: any,index: number) => {
						const viewed = i.responses.filter((item: any) => item.viewed == Constants.QUOTE_RESPONSE_VIEWED.VIEWED).length;
						const not_viewed = i.responses.filter((item: any) => item.viewed == Constants.QUOTE_RESPONSE_VIEWED.NOT_VIEWED).length;

						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD-MM-YYYY') }</td>
								<td>{ i?.service?.name }</td>
								<td>{ i?.patient }</td>
								<td>
									<a href="#" onClick={ (e: any) => this.view(e,i) }>Ver</a>
								</td>
								<td className="viewed">{ viewed }</td>
								<td className={ `viewed ${ not_viewed > 0 ? 'red' : '' }` }>{ not_viewed }</td>
								<td className="text-right">
									<Tooltip title="Ver">
										<a target="_blank" className="link-icon" href="#" onClick={ (e: any) => this.download(e,i) }>
											<img src={ EyeBlackIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ DeleteIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Quotes);